import {
  useGetUniversalSearchJobsQuery,
  useGetUniversalSearchTalentQuery,
} from "../api";
import type { UniversalTabValue } from "../constants";
import { useDebouncedUniversalSearchPhrase } from "../universal-search-slice";

export type UseUniversalSearchEmptyDataArg = {
  currentTab: UniversalTabValue;
  isFetching: boolean;
  canAccessPeople: boolean;
};

export const useUniversalSearchEmptyData = ({
  currentTab,
  isFetching,
  canAccessPeople,
}: UseUniversalSearchEmptyDataArg) => {
  const search = useDebouncedUniversalSearchPhrase();
  const commonSkip = isFetching;

  const { currentData: jobResults, isFetching: isFetchingJobs } =
    useGetUniversalSearchJobsQuery(
      { search },
      { skip: currentTab === "JOBS" || commonSkip },
    );
  const { currentData: talentResults, isFetching: isFetchingTalents } =
    useGetUniversalSearchTalentQuery(
      { search },
      { skip: currentTab === "PEOPLE" || commonSkip || !canAccessPeople },
    );

  return {
    data: { talentResults, jobResults },
    isLoading: isFetching || isFetchingJobs || isFetchingTalents,
  };
};
